import { NgModule } from '@angular/core';
import { SupCurrencyPipe } from './sup.currency.pipe';
import { TimeFromNumberPipe } from './time-from-number.pipe';
import { PhoneNumberFormatPipe } from './phone-number-format.pipe';

@NgModule({
    declarations: [SupCurrencyPipe, TimeFromNumberPipe, PhoneNumberFormatPipe],
    exports: [SupCurrencyPipe, TimeFromNumberPipe, PhoneNumberFormatPipe]
})
export class TrademeCoreUiPipeModule {}
